<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/settings/mails/update"
      search_title="تعديل"
      icon="fa-edit"
    />
    <MainLoader v-if="loading"></MainLoader>
    <main v-if="data && !loading">
      <div class="container row justefiy-content-center">
        <div
          class="col-lg-6"
          v-for="(email, index) in data.public_emails"
          :key="email"
        >
          <div class="filed_item">
            <h6>البريد الالكتروني رقم {{ index + 1 }}</h6>
            <p>{{ email }}</p>
          </div>
        </div>
      </div>
      <div class="container row justefiy-content-center">
        <div class="col-lg-6" v-for="item in data.socials" :key="item">
          <div class="filed_item">
            <h6>{{ item.social_title }}</h6>
            <p>{{ item.social_link }}</p>
            <span> كود الايكون : {{ item.social_icon }}</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.settings.title"),
          disabled: false,
          href: "/settings/mails",
        },
        {
          text: this.$t("breadcrumb.settings.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      data: null,
      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [],

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      loading: false,
    };
  },

  watch: {
    [`paginations.current_page`]() {
      this.setRows();
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "البريد الالكتروني",
            align: "center",
            value: "email",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/settings/about/add" });
    },
    // showItem(item) {
    //   this.$router.push({ path: '/settings/about/show/' + item.id })
    // },
    editItem(item) {
      this.$router.push({ path: "/settings/about/edit/" + item.id });
    },

    // Set Rows
    getData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "setting",
      })
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.loading = false;
        });
    },
  },

  created() {
    // this.canEdit = this.$permission.allowed("projects/edit/");
    // this.canDelete = this.$permission.allowed("projects/delete");
    this.canAdd = this.$permission.allowed("settings/mails/update");
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.filed_item {
  // border: 1px solid var(--mainColor-2);
  border-radius: 30px;
  h6 {
    color: var(--mainColor-2);
    font-weight: 600;
  }
  p {
  }
}
</style>
